(function($){

	// ========================================================
	// GLOBALS
	// ========================================================

	const Globals = {
		// Variables
		$body: $('body'),
		$window: $(window),
		$document: $(document),
		// Methods
		addMobileDetection: function() {
			// @link https://dev.to/timhuang/a-simple-way-to-detect-if-browser-is-on-a-mobile-device-with-javascript-44j3
			if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
				this.$body.addClass('is-mobile');
			}
		},
		add: function(key, val) {
			this[key] = val;
		}
	}

	Globals.addMobileDetection();

	Globals.add('sliders', {
		nextArrow: `<button class="slick-next slick-arrow" aria-label="Next" type="button"><svg xmlns="http://www.w3.org/2000/svg" width="11" height="18"><path fill="none" stroke="currentColor" stroke-width="3" d="m1.06 1.06 7.8 7.8-7.8 7.8" data-name="Path 1"/></svg></button>`,
		prevArrow: `<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><svg xmlns="http://www.w3.org/2000/svg" width="11" height="18"><path fill="none" stroke="currentColor" stroke-width="3" d="m9.924 16.665-7.8-7.8 7.8-7.8" data-name="Path 1348"/></svg></button>`,
	});

	// ========================================================
	// INCLUDE PARTIAL FILES VIA GULP-INCLUDE
	// ========================================================

	/**
	 * Gets the promo code used for source tracking.
	 *
	 * First checks URL string for variable (i.e. ?promo=12345).
	 * Otherwise, look in our TriMark coookie for the code.
	 *
	 * Cookie is set in partials/source-tracker.js
	 *
	 * @returns string
	 */
	function getPromoCode() {
		const urlVars = new URLSearchParams(window.location.search);
	    const cookieVars = Cookies.get('trmk_src_first') ? JSON.parse(Cookies.get('trmk_src_first')) : {};
	
		// First check for promo code in URL
		if (urlVars.get('promo')) {
			return urlVars.get('promo');
		}
	
		// Otherwise fallback to cookie value
		return cookieVars.hasOwnProperty('promo') ? cookieVars.promo : false;
	}
	
	/**
	 * ChatInterceptor function
	 *
	 * Fired by Apex chat when user interacts with chat. This allows us to hook into the
	 * chat and pass through our promo code and set a default one if needed.
	 *
	 * @returns null
	 */
	window.ChatInterceptor = function() {
	    try {
	        let promo = getPromoCode();
			if (!promo) {
				promo = TRIMARK_GLOBALS.default_promos.apex_chat;
			}
	        return promo;
	    } catch (e) {
	        console.log(e);
	    }
	};
	
	// ========================================================
	// PRIMARY NAVIGATION
	// - Classes to note:
	//   - "is-hover" for hover events (mainly desktop)
	//   - "is-active" for focus and click events (mainly mobile)
	// ========================================================
	
	// Document ready
	$(() => {
	
		// ========================================================
		// INITIALIZE THE DESKTOP MEGA MENU - SUPERFISH
		// ========================================================
	
		$('.primary-nav .navbar__nav').superfish({
			popUpSelector: '.sf-mega',
			hoverClass: 'is-hover',
			delay: 500,
			onBeforeShow: function () {
				const $menu = $(this);
				const $image = $menu.find('.sf-mega__image img');
	
				// Lazy load initial image (do not run updateMenuImage() here)
				$image.attr('src', $image.data('src'));
	
				// Add class to body for a gradient background behind menu
				if ($menu.hasClass('sf-mega')) {
					$('body').addClass('menu-shown');
				}
	
				// Detect if we have grandchild pages and adjust the image height
				if ($menu.find('.sf-mega__menu-menu > li:first-child').hasClass('menu-item-has-children')) {
					$menu.find('.sf-mega__slot').addClass('has-active-menu');
				}
			},
			onBeforeHide: function () {
				if ($(this).hasClass('sf-mega')) {
					$('body').removeClass('menu-shown');
				}
			},
			onHide: function() {
				resetMegaMenu($(this));
			}
		});
	
	
		// ========================================================
		// UTILITY FUNCTIONS
		// ========================================================
	
		/**
		 * Update the menu image based on a dom element passed in.
		 * This is the tag with [data-image] set on it
		 *
		 * @param {object} domEl
		 * @param {string} event
		 */
		function updateMenuImage(domEl) {
			const $this = $(domEl);
			const $megaMenu = $this.parents('.sf-mega');
			const $imageSlot = $megaMenu.find('.sf-mega__slot .sf-mega__image');
	
			// Return early if no image is set
			if (!$this.data('image')) {
				return false;
			}
	
			const imageUrl = $this.data('image');
			const $curImage = $imageSlot.find('img');
			let preloaderImg = document.createElement("img");
			preloaderImg.src = imageUrl;
			preloaderImg.style.display = 'none';
	
			// Return early if images are the same
			if ($curImage.attr('src') === preloaderImg.src) {
				return;
			}
	
			// Fade out and remove old image
			$curImage.fadeOut(600, function() {
				$(this).remove();
			});
	
			// Listen for image load event
			preloaderImg.addEventListener('load', () => {
				$imageSlot.prepend(preloaderImg); // add in new image
				$imageSlot.find('img').fadeIn(300); // then fade it in
				preloaderImg = null;
			});
	
			// Update height of image slot (doing this last feels marginally more smooth /shrug?)
			if (!$this.parent().hasClass('panel-item')) {
				const menuItemHasChildren = $this.parent().hasClass('menu-item-has-children');
				$megaMenu.find('.sf-mega__slot').toggleClass('has-active-menu', menuItemHasChildren);
			}
		}
	
		/**
		 * Reset a mega menu back to its initial state.
		 *
		 * @param {object} $menu
		 */
		function resetMegaMenu($menu) {
			const $firstLi = $menu.find('.sf-mega__menu-menu > li:first-child');
			const firstLiHasChildren = $firstLi.hasClass('menu-item-has-children');
	
			// Remove .is-active class from any menu items
			$menu.find('.sf-mega__menu-menu > li').removeClass('is-active');
			// Activate first menu item
			$menu.find('.menu-item-has-children:first-child').addClass('is-active');
			// Update the menu image back to the first one
			updateMenuImage($firstLi.find('> a'));
			// Activate grandchild menu if first menu item has children
			$menu.find('.sf-mega__slot').toggleClass('has-active-menu', firstLiHasChildren);
			// Deactivate any shown grandchild menus
			$menu.find('.sf-mega__slot-menu .panel').removeClass('is-shown');
			// Activate correct granchild menu (if applicable)
			if (firstLiHasChildren) {
				$menu.find('.sf-mega__slot-menu').show().find('.panel:first-child').addClass('is-shown');
			}
			// Unhide menu image in case it's been hidden
			$menu.find('.sf-mega__image').show();
		}
	
		// ========================================================
		// 1ST LEVEL DROPDOWNS (CHILD PAGES)
		// ========================================================
	
		/**
		 * Trigger grandchild page menu panel
		 * - Trigger image change
		 * - Trigger 2nd level menu (slot menu) updates
		 */
		function triggerChildPage(e) {
			const $menuItem = $(e.currentTarget);
			const $anchor = $menuItem.find('> a');
			const targetID = $anchor.data('id');
	
			updateMenuImage($anchor[0]);
	
			$menuItem.addClass('is-active').siblings().removeClass('is-active');
	
			if ($menuItem.hasClass('menu-item-has-children')) {
				$menuItem.parents('.sf-mega').find('.sf-mega__slot-menu').show();
				$(`#panel-${targetID}`).addClass('is-shown').siblings().removeClass('is-shown');
				if ($(`#panel-${targetID}`).is('.panel:has(.panel-sub-menu)')) {
					$menuItem.parents('.sf-mega').find('.sf-mega__image').hide();
				} else {
					$menuItem.parents('.sf-mega').find('.sf-mega__image').show();
				}
			} else {
				$menuItem.parents('.sf-mega').find('.sf-mega__slot-menu').hide();
				$menuItem.parents('.sf-mega').find('.sf-mega__image').show();
			}
		}
		$('.sf-mega__menu > ul > li.menu-item').hoverIntent(e => triggerChildPage(e));
		$('.sf-mega__menu > ul > li.menu-item').on('focusin', e => triggerChildPage(e));
	
		/**
		 * KEYBOARD
		 * Child menu item focusout triggers grandchild menu activation.
		 */
		$('.sf-mega__menu > ul > li.menu-item-has-children a').on('focusout', e => {
			const targetID = $(e.currentTarget).data('id');
	
			e.stopPropagation();
	
			$(`#panel-${targetID} > li:first-child > a`).trigger('focus');
		});
	
		// ========================================================
		// 2ND LEVEL MENU INTERACTIONS (GRANDCHILD PAGES)
		// ========================================================
	
		/**
		 * Mouseenter event
		 * - Changes the menu image
		 */
		$('.sf-mega__slot-menu a').on({
			mouseenter: e => updateMenuImage(e.currentTarget)
		});
	
		/**
		 * KEYBOARD
		 * Last grandchild focusout resets focus back to child navigation
		 */
		$('.sf-mega__slot-menu li.menu-item:last-child a').on('focusout', e => {
			const $this = $(e.currentTarget);
			const id = $this.parents('.panel').attr('id').slice(6); // i.e. "panel-"
			const $parent = $this.parents('.sf-mega').find(`[data-id="${id}"]`).parent();
	
			e.stopPropagation();
	
			$parent.next('li.menu-item').find('a').trigger('focus');
		})
	
	
		// ========================================================
		// STICKY MENU (DESKTOP & MOBILE)
		// ========================================================
	
		/**
		 * Sticky menu
		 * - Desktop - becomes sticky after scrolling certain amount
		 * - Mobile - becomes sticky only when scrolling up
		 * - Self initializing function
		 */
		const initStickyMenu = (() => {
			const { $window, $document } = Globals;
			const $header = $('#header');
			const navbarHeight = $header.outerHeight();
			const isMobile = $window.width() < 992;
	
			let didScroll = false;
			let lastScrollTop = 0;
	
			// Mobile Header Slide In/Out - Hide and Show header on scroll down and up
			function hasScrolled() {
				let st = $window.scrollTop();
	
				// Make sure they scroll more than 5px
				if (Math.abs(lastScrollTop - st) <= 5) return;
	
				// Mobile sticky when scrolling up
				if (isMobile) {
	
					// If they scrolled down and are past the navbar, add class .nav-up.
					// This is necessary so you never see what is "behind" the navbar.
					if (st > lastScrollTop && st > navbarHeight) { // Scroll Down
						// Uncomment next line to hide navbar when scrolling down
						// $header.removeClass('shown top').addClass('hidden');
	
						// Comment out next line if above line is enabled
						$header.removeClass('top');
					} else if (st + $window.height() < $document.height()) { // Scroll Up
						$header.removeClass('hidden').addClass('shown');
						if (st <= 0) { // scrollTop will read less than 0 on mobile safari
							$header.addClass('top');
						}
					}
	
				// Desktop, sticky after certain distance
				} else {
					// Hide
					if (st < 800) {
						$header.removeClass('shown top').addClass('hidden');
						if (st <= 0) { // scrollTop will read less than 0 on mobile safari
							$header.addClass('top');
						}
					// Show
					} else {
						$header.removeClass('hidden top').addClass('shown');
					}
				}
	
				lastScrollTop = st;
			}
	
			$window.on('scroll', event => {
				didScroll = true;
			});
	
			setInterval(() => {
				if (didScroll) {
					hasScrolled();
					didScroll = false;
				}
			}, 250);
	
		})();
	
		// ========================================================
		// MOBILE MENU (FLYOUT PANELS)
		// ========================================================
	
		// Trigger menu open
		$('.navbar__toggler').on('click', () => {
			$('.site-header').toggleClass('mobile-menu-open');
			$('body').toggleClass('no-scroll');
		});
	
		// Trigger child and grandchild page flyouts
		$('li.menu-item').on('click', e => {
			$(e.currentTarget).addClass('is-active')
		});
	
		// Prevent clicks on actual menu links from triggering panel flyouts
		$('li.menu-item > a').on('click', e => {
			e.stopPropagation();
			e.stopImmediatePropagation();
		});
	
		// Trigger menu "back" functionality
		$('.sub-menu-header').on('click', e => {
			e.stopPropagation();
			$(e.currentTarget).closest('.is-active').removeClass('is-active');
		});
	
	});
	
	const SourceTracker = settings => {
		const module = {
			settings,
			init: function() {
				if (typeof Cookies === 'undefined') {
					console.info('Please install js-cookie library to enable the SourceTracker library.');
					return;
				}
				this.setSourceCookies();
			},
			setSourceCookies: function() {
				const params = new URLSearchParams(window.location.search);
				const cookie = {};
	
				// Save all url params in cookie object
				params.forEach((val, key) => cookie[key] = val);
	
				// Add any additional values to cookie object
				cookie['referrer'] = document.referrer;
				cookie['landing_pg'] = window.location.href;
	
				// Save first-touch cookie (only if not previously set)
				if (typeof Cookies.get(this.settings.cookie.name.ft) === 'undefined') {
					Cookies.set(this.settings.cookie.name.ft, JSON.stringify(cookie), this.settings.cookie.opts);
				}
	
				// In all instances save last-touch cookie
				Cookies.set(this.settings.cookie.name.lt, JSON.stringify(cookie), this.settings.cookie.opts);
			},
			populateFormFields: function() {
				const cookieName = this.settings.cookie.name[this.settings.strategy];
				const vars = Cookies.get(cookieName) ? JSON.parse(Cookies.get(cookieName)) : {};
				const _self = this;
	
				Object.keys(vars).forEach(key => {
					$(`[${_self.settings.forms.prefillAttr}="${key}"]`).each((i, el) => {
						$(el).val(vars[key]);
					});
				});
			}
		}
	
		module.init();
	
		return module;
	}
	
	/**
	 * Jquery document ready.
	 * Initialize SourceTracker library.
	 */
	$(() => {
		// Init source tracking library
		const st = new SourceTracker({
			strategy: 'ft', // "ft" or "lt" (first-touch or last-touch)
			cookie: {
				name: {
					ft: 'trmk_src_first', // cookie name : first touch attribution
					lt: 'trmk_src_last', // cookie name : last touch attribution
				},
				opts: {
					expires: 1, // 1 day
					path: '/' // full site
				}
			},
			forms: {
				prefillAttr: 'data-prefill', // the data attribute of form field to prefill
			},
		});
	
		// Gravity forms post render event
		// - Makes sure fields are always popuplated with correct cookie values even if re-rendered (i.e. validation)
		$(document).on('gform_post_render', function (event, form_id, current_page) {
			st.populateFormFields();
		});
	
		// Fallback for if gform_post_render doesn't fire
		// - gform_post_render is supposed to fire on page load, but seems to not in all cases
		st.populateFormFields();
	})
	
	/**
	 * Vendor: Media Culture / The Trade Desk
	 *
	 * This controller handles pixel placement on the site. The init() method
	 * is pasted in exact contents from vendor.
	 *
	 * Requires a Media Culture Synthetic User ID as generated by the
	 * MediaCulture controller.
	 */
	const FlashTalking = {
		/**
		 * Pixels
		 */
		pixels: {
			conversion: `<script type="text/javascript">((function (e, t) {var n = function () {var e = t.createElement("iframe");e.src = "https://servedby.flashtalking.com/container/28894;140670;15898;iframe/?spotName=Quote_Complete&ftXCurrency=[%INSERT_TRANSACTION_CURRENCY_HERE%]&ftXName=[%INSERT_TRANSACTION_NAME_HERE%]&ftXNumItems=[%INSERT_TRANSACTION_QUANTITY_HERE%]&ftXRef=[%INSERT_TRANSACTION_ID_HERE%]&ftXType=[%INSERT_TRANSACTION_TYPE_HERE%]&ftXValue=[%INSERT_TRANSACTION_VALUE_HERE%]&cachebuster=" + (Math.random() * 1e6);e.style.cssText="position: absolute;visibility: hidden;width: 1px;height: 1px;";t.body.appendChild(e)};if(t.readyState==="complete"){n()}else{if(typeof e.addEventListener!=="undefined"){t.addEventListener("DOMContentLoaded",n,false)}else{e.attachEvent("onload",n,false)}}})(window,document));</script>`,
			ctc: `<script type="text/javascript">((function (e, t) {var n = function () {var e = t.createElement("iframe");e.src = "https://servedby.flashtalking.com/container/28894;140671;15898;iframe/?spotName=Click_to_Call&ftXCurrency=[%INSERT_TRANSACTION_CURRENCY_HERE%]&ftXName=[%INSERT_TRANSACTION_NAME_HERE%]&ftXNumItems=[%INSERT_TRANSACTION_QUANTITY_HERE%]&ftXRef=[%INSERT_TRANSACTION_ID_HERE%]&ftXType=[%INSERT_TRANSACTION_TYPE_HERE%]&ftXValue=[%INSERT_TRANSACTION_VALUE_HERE%]&cachebuster=" + (Math.random() * 1e6);e.style.cssText="position: absolute;visibility: hidden;width: 1px;height: 1px;";t.body.appendChild(e)};if(t.readyState==="complete"){n()}else{if(typeof e.addEventListener!=="undefined"){t.addEventListener("DOMContentLoaded",n,false)}else{e.attachEvent("onload",n,false)}}})(window,document));</script>`
		},
		/**
		 * Init method
		 * (contents pasted exactly from vendor)
		 */
		init: function() {
			// Universal Script/Pixel
			var ft_onetag_15897 = {
				ft_vars:{
					"ftXRef": MediaCulture._getSUID(), // <-- INSERT "TRANSACTION_ID" --
					"ftXValue":"", // <-- INSERT "TRANSACTION_VALUE" --
					"ftXType":"", // <-- INSERT "TRANSACTION_TYPE" --
					"ftXName":"", // <-- INSERT "TRANSACTION_NAME" --
					"ftXNumItems":"", // <-- INSERT "TRANSACTION_QUANTITY" --
					"ftXCurrency":"", // <-- INSERT "TRANSACTION_CURRENCY" --
					},
				ot_dom:'https://servedby.flashtalking.com',
				ot_path:'/container/28894;140664;15897;iframe/?',
				ot_href:'ft_referrer='+escape(document.location.href),
				ot_rand:Math.random()*1000000,
				ot_ref:document.referrer,
				ot_init:function(){
					var o=this,qs='',count=0,ns='';
					for(var key in o.ft_vars){
						qs+=(o.ft_vars[key]==''?'':key+'='+o.ft_vars[key]+'&');
					}
					count=o.ot_path.length+qs.length+o.ot_href+escape(o.ot_ref).length;
					ns=o.ot_ns(count-2000);
					var ifrm = document.createElement('iframe');
					  ifrm.style.cssText = 'width:1px;height:1px;position:absolute;display:none;';
					  ifrm.src = o.ot_dom + o.ot_path + qs + o.ot_href + encodeURIComponent('?~'+qs) + '&ns=' + ns + '&cb=' + o.ot_rand;
					  document.body.appendChild(ifrm);
				},
				ot_ns:function(diff){
					if(diff>0){
						var o=this,qo={},
							sp=/(?:^|&)([^&=]*)=?([^&]*)/g,
							fp=/^(http[s]?):\/\/?([^:\/\s]+)\/([\w\.]+[^#?\s]+)(.*)?/.exec(o.ot_ref),
							ro={h:fp[2],p:fp[3],qs:fp[4].replace(sp,function(p1,p2,p3){if(p2)qo[p2]=[p3]})};
						return escape(ro.h+ro.p.substring(0,10)+(qo.q?'?q='+unescape(qo.q):'?p='+unescape(qo.p)));
					}else{
						var o=this;
						return escape(unescape(o.ot_ref));
					}
						}
				}
			ft_onetag_15897.ot_init();
		}
	}
	
	
	/**
	 * Vendor: Media Culture / The Trade Desk
	 *
	 * This controller handles the generation of a vendor "Synthetic User ID" (SUID) and pixel
	 * placement on site pages. The SUID is passed through in form conversions (through hidden field)
	 * as well as in pixel scripts themselves.
	 *
	 * Requires this script to be included on the page AHEAD of initialization:
	 * <script src="https://js.adsrvr.org/up_loader.1.1.0.js" type="text/javascript"></script>
	 */
	const MediaCulture = {
		/**
		 * The Synthetic User ID
		 * A unique identifier.
		 */
		suid: '',
		/**
		 * Quote forms for generating leads
		 */
		$quoteForms: $('#gform_1, #gform_2, #gform_3, #gform_4'),
		/**
		 * Pixels
		 */
		pixels: {
			tradeDesk: {
				universal: `<script type="text/javascript">ttd_dom_ready(function(){"function"==typeof TTDUniversalPixelApi&&new TTDUniversalPixelApi().init("sw4wj8z",["i8co40h"],"https://insight.adsrvr.org/track/up")});</script>`,
				conversion: `<img height="1" width="1" style="border-style:none;" alt="" src="https://insight.adsrvr.org/track/pxl/?adv=sw4wj8z&ct=0:wn4roaz&fmt=3&td1={td1}"/>`,
				ctc: `<img height="1" width="1" style="border-style:none;" alt="" src="https://insight.adsrvr.org/track/pxl/?adv=sw4wj8z&ct=0:40aa74m&fmt=3&td1={td1}"/>`,
				session: `<img height="1" width="1" style="border-style:none;" alt="" src="https://insight.adsrvr.org/track/pxl/?adv=sw4wj8z&ct=0:15togpj&fmt=3"/>`
			},
			insp: {
				landingPg: `<img src="https://connect.blockboardtech.com/track/t?e=Impression&vr=1&d=eJwzNDc0MjIxNrAwMTY30jGyMLHQMTQzMjHSMbQ0t7TUMTQ3MIAQBjqhedl5.eV5OgZoEITQBcAUVBiqPS0xpzhVxxAAQMIX3Q--&m=1&op5=[VALUE-1]&op6=[VALUE-2]&op7=[VALUE-3]&op8=[VALUE-4]&op9=[VALUE-5]&op10=[VALUE-6]" width="1" height="1" border="0">`,
				freeQuotePg: `<img src="https://connect.blockboardtech.com/track/t?e=Impression&vr=1&d=eJwzNDc0MjIxNjQ2NDc01TGyMLHQMTQDCugYWppbWuoYmhsYQggDndC87Lz88jwgCxWCELoAmIIKQ7WnJeYUp.oYAgA_TBfb&m=1&op5=[VALUE-1]&op6=[VALUE-2]&op7=[VALUE-3]&op8=[VALUE-4]&op9=[VALUE-5]&op10=[VALUE-6]" width="1" height="1" border="0">`,
				conversion: `<img src="https://connect.blockboardtech.com/track/t?e=Impression&vr=1&d=eJwzNDc0MjIxNjQ1MjQx1jGyMLHQMTQzMjHRMbQ0t7TUMTQ3MIIQBjqhedl5.eV5QBYqBCF0ATAFFYZqT0vMKU7VMQQAP4IX3Q--&m=1&op5=[VALUE-1]&op6=[VALUE-2]&op7=[VALUE-3]&op8=[VALUE-4]&op9=[VALUE-5]&op10=[VALUE-6]" width="1" height="1" border="0">`
			}
		},
		/**
		 * INTERNAL
		 *
		 * Create the Synthetic User ID
		 */
		_createSUID: function() {
			// @link https://paulius-repsys.medium.com/simplest-possible-way-to-generate-unique-id-in-javascript-a0d7566f3b0c
			const randomness = Math.random().toString(36).substr(2);
			this.suid = randomness;
		},
		/**
		 * INTERNAL
		 *
		 * Get the Synthetic User ID
		 *
		 * @returns string
		 */
		_getSUID: function() {
			return this.suid;
		},
		/**
		 * Replaces a placeholder value in a string with the
		 * Synthetic User ID.
		 *
		 * @param {string} pixel The pixel string with the placeholder that should be replaced
		 * @param {string} placeholder The placeholder value that should be replaced
		 * @returns string
		 */
		_getPixelWithSUID: function(pixel, placeholder) {
			return pixel.replace(placeholder, this._getSUID());
		},
		/**
		 * Prefill form fields with the SUID
		 */
		_prefillFormFields: function() {
			MediaCulture.$quoteForms.find('input[data-prefill="suid"]').each((i, el) => {
				$(el).val(MediaCulture._getSUID());
			});
		},
		/**
		 * Init Method
		 */
		init: function() {
			this._createSUID();
			this._prefillFormFields();
		},
		/**
		 * Fire pixels that should be fired on all pages
		 */
		fireOnAllPages: function() {
			Globals.$body.append(this.pixels.tradeDesk.universal);
			Globals.$body.append(this.pixels.tradeDesk.session);
			Globals.$body.append(this._getPixelWithSUID(this.pixels.insp.landingPg, '[VALUE-1]'));
		},
		/**
		 * Fire pixels that should only be fired on quote form pages.
		 */
		fireOnQuoteFormPages: function() {
			if (this.$quoteForms.length > 0) {
				Globals.$body.append(MediaCulture._getPixelWithSUID(MediaCulture.pixels.insp.freeQuotePg, '[VALUE-1]'));
			}
		},
		/**
		 * Fire pixels on form submissions
		 */
		fireOnConversion: function() {
			var quoteFormIds = this.$quoteForms.map(function(){return parseInt(this.getAttribute('data-formid'))}).get();
	
			$(document).on('gform_post_render', function(event, formId) {
				// All forms are set to redirect to a TY page so if we are redirecting, the form submitted successfully
				if (window['gformRedirect'] && quoteFormIds.indexOf(formId) !== -1) {
					Globals.$body.append(MediaCulture._getPixelWithSUID(MediaCulture.pixels.tradeDesk.conversion, '{td1}'));
					Globals.$body.append(MediaCulture._getPixelWithSUID(MediaCulture.pixels.insp.conversion, '[VALUE-1]'));
					Globals.$body.append(MediaCulture._getPixelWithSUID(FlashTalking.pixels.conversion, '[%INSERT_TRANSACTION_ID_HERE%]'));
				}
			});
		},
		/**
		 * Fire pixels on click to call anchor links.
		 */
		fireOnClickToCall: function() {
			$('a[href^="tel:"]').on('click', function() {
				Globals.$body.append(MediaCulture._getPixelWithSUID(MediaCulture.pixels.tradeDesk.ctc, '{td1}'));
				Globals.$body.append(MediaCulture._getPixelWithSUID(FlashTalking.pixels.ctc, '[%INSERT_TRANSACTION_ID_HERE%]'));
			});
		}
	}
	
	/**
	 * Vendor: Media Culture / The Trade Desk
	 *
	 * Initialize all functions on $(document).ready
	 */
	$(() => {
		MediaCulture.init();
		FlashTalking.init();
		MediaCulture.fireOnAllPages();
		MediaCulture.fireOnQuoteFormPages();
		MediaCulture.fireOnClickToCall();
		MediaCulture.fireOnConversion();
	});
	
	// ========================================================
	// LANGUAGE TRANSLATIONS
	// (mostly just for translating Gravity Forms on the fly)
	// ========================================================
	
	const translate = () => {
		// Look for string translations in global window variable which reads
		// strings from backend plugin admin page.
		const translations = TRIMARK_VARS.translations;
	
		// Forms Inputs
		$('form input[placeholder], form input[type="button"], form input[type="submit"]').each((i, input) => {
			const $input = $(input);
			const type = $input.attr('type');
	
			// Submit or page buttons
			if (type === 'submit' || type === 'button') {
				const text = $input.val();
				if (translations.hasOwnProperty(text)) {
					$input.val(translations[text]);
				}
			}
			// All other inputs (with a placeholder value)
			else {
				const placeholder = $input.attr('placeholder');
				if (translations.hasOwnProperty(placeholder)) {
					$input.attr('placeholder', translations[placeholder]);
				}
			}
		});
	
		// Form Disclaimer
		$('.form-disclaimer').each((i, el) => {
			const $this = $(el);
			const translatedVal = translations.hasOwnProperty('{{FORM_DISCLAIMER}}') ? translations['{{FORM_DISCLAIMER}}'] : null;
	
			if (translatedVal) {
				$this.html(translatedVal);
			}
		});
	
		// Form Error Messages and Labels
		$('.gfield_validation_message, .gform_submission_error, .gfield_label, .gform-field-label').each((i, el) => {
			const $this = $(el);
			const text = $this.text();
			const translatedVal = translations.hasOwnProperty(text) ? translations[text] : null;
	
			if (translatedVal) {
				$this.text(translatedVal);
			}
		});
	}
	
	// Translate on document ready
	window.addEventListener('DOMContentLoaded', () => {
		translate();
	});
	
	// Also translate when multi-step form pages are shown/hidden
	$(document).on('gform_post_render', function (event, form_id, current_page) {
		translate();
	});
	
	const ProductFeatures = function($selector) {
		const module = {
			opts: {
				$module: $selector,
				breakpoint: 768,
				selectors: {
					slider: '.product-features__slider',
					sliderNav: '.js-slider-controls',
					tabContent: '.product-features__groups',
					tabPanel: '.product-features__group',
					tabNav: '.product-features__nav',
					tab: '.product-features__nav .nav-link',
					hotspots: '.hotspots',
					hotspot: '.hotspot',
				}
			},
			data: {
				$activeTabPanel: {},
				$activeSlider: {},
				$activeHotspotPanel: {},
			},
			bindEvents: function() {
				// Tab shown
				this.opts.$module.find(this.opts.selectors.tab).on('shown.bs.tab', this.handleTabChange.bind(this));
				// Hotspot clicked
				this.opts.$module.find(this.opts.selectors.hotspot).on('click', this.handleHotspotClick.bind(this));
			},
			init: function() {
				// Bind any events we need
				this.bindEvents();
	
				// Kickoff main change event to initialize
				if ($(window).width() < this.opts.breakpoint) {
					this.initMobileSliders();
				} else {
					this.handleTabChange();
				}
			},
			handleTabChange: function(e = null) {
				let $activeTabPanel = e ? $(e.target) : this.opts.$module.find(`${this.opts.selectors.tabPanel}.active`);
	
				// If we have a tab change event
				if (e) {
					const target = $(e.target).data('bs-target')
					$activeTabPanel = $(target);
				}
				// Otherwise, setup default
				else {
					$activeTabPanel = this.opts.$module.find(`${this.opts.selectors.tabPanel}.active`);
				}
	
				// Save internal variables
				this.data.$activeTabPanel = $activeTabPanel;
				this.data.$activeSlider = $activeTabPanel.find(this.opts.selectors.slider);
				this.data.$activeHotspotPanel = $(`${this.opts.selectors.hotspots}[data-index="${$activeTabPanel.data('index')}"]`);
	
				// Trigger methods
				this.initSlider();
				this.initHotspots();
			},
			initSlider: function() {
				const _self = this;
	
				if (this.data.$activeSlider.hasClass('slick-initialized')) {
					return;
				}
	
				this.data.$activeSlider.each((i, el) => {
					const $slider = $(el);
					const $controls = $slider.next(_self.opts.selectors.sliderNav);
					const { nextArrow, prevArrow } = Globals.sliders;
	
					$slider.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
						_self.data.$activeHotspotPanel.find(`${_self.opts.selectors.hotspot}[data-id="${nextSlide}"]`).addClass('active').siblings().removeClass('active');
					}).slick({
						nextArrow, // defined in scripts.js
						prevArrow, // defined in scripts.js
						dots: true,
						appendDots: $controls,
						appendArrows: $controls,
						infinite: false
					});
				});
			},
			initMobileSliders: function() {
				const _self = this;
	
				$(_self.opts.selectors.slider).each((i, el) => {
					const $slider = $(el);
					const $controls = $slider.next(_self.opts.selectors.sliderNav);
					const { nextArrow, prevArrow } = Globals.sliders;
	
					$slider.slick({
						nextArrow, // defined in scripts.js
						prevArrow, // defined in scripts.js
						dots: true,
						appendDots: $controls,
						appendArrows: $controls,
						slidesToShow: 1.25,
						infinite: false
					});
				});
			},
			initHotspots: function() {
				this.data.$activeHotspotPanel.addClass('active').siblings().removeClass('active');
			},
			handleHotspotClick: function(e) {
				const $hotspot = $(e.currentTarget);
				const targetSlide = $hotspot.data('id');
	
				$hotspot.addClass('active').siblings().removeClass('active');
				this.data.$activeSlider.slick('slickGoTo', targetSlide);
			}
		}
	
		if ($selector.length) {
			module.init();
		}
	
		return module;
	}
	
	
	/**
	 * Register after jQuery doc ready
	 */
	$(() => {
		new ProductFeatures($('.block-product-features'));
	});
	
	const InteractiveMap = function($selector) {
		const module = {
			opts: {
				$module: $selector,
				styles: [{"featureType":"all","elementType":"labels.text.fill","stylers":[{"color":"#7c93a3"},{"lightness":"-10"}]},{"featureType":"administrative.country","elementType":"geometry","stylers":[{"visibility":"on"}]},{"featureType":"administrative.country","elementType":"geometry.stroke","stylers":[{"color":"#a0a4a5"}]},{"featureType":"administrative.province","elementType":"geometry.stroke","stylers":[{"color":"#62838e"}]},{"featureType":"landscape","elementType":"geometry.fill","stylers":[{"color":"#e9f0f6"}]},{"featureType":"landscape.man_made","elementType":"geometry.stroke","stylers":[{"color":"#3f4a51"},{"weight":"0.30"}]},{"featureType":"poi","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"poi.attraction","elementType":"all","stylers":[{"visibility":"on"}]},{"featureType":"poi.business","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"poi.government","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"poi.park","elementType":"all","stylers":[{"visibility":"on"}]},{"featureType":"poi.place_of_worship","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"poi.school","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"poi.sports_complex","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"all","stylers":[{"saturation":"-100"},{"visibility":"on"}]},{"featureType":"road","elementType":"geometry.stroke","stylers":[{"visibility":"on"}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#bbcacf"}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"lightness":"0"},{"color":"#bbcacf"},{"weight":"0.50"}]},{"featureType":"road.highway","elementType":"labels","stylers":[{"visibility":"on"}]},{"featureType":"road.highway","elementType":"labels.text","stylers":[{"visibility":"on"}]},{"featureType":"road.highway.controlled_access","elementType":"geometry.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"road.highway.controlled_access","elementType":"geometry.stroke","stylers":[{"color":"#a9b4b8"}]},{"featureType":"road.arterial","elementType":"labels.icon","stylers":[{"invert_lightness":true},{"saturation":"-7"},{"lightness":"3"},{"gamma":"1.80"},{"weight":"0.01"}]},{"featureType":"transit","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"geometry.fill","stylers":[{"color":"#bed0de"}]}],
				selectors: {}
			},
			map: {},
			bindEvents: function() {},
			init: function() {
				this.map = this.initMap();
				this.initMarkers();
				this.centerMap();
			},
			initMap: function() {
				const { $module, styles } = this.opts;
				const map = new google.maps.Map( $module[0], {
					zoom : $module.data('zoom') || 4,
					mapTypeId : 'roadmap', // google.maps.MapTypeId.ROADMAP,
					center: { lat: -25.344, lng: 131.031 },
					disableDefaultUI: true,
					styles
				});
				return map;
			},
			initMarkers: function() {
				this.map.markers = [];
				this.opts.$module.data('markers').forEach(marker => this.addMarker(marker));
			},
			addMarker: function(data) {
				const marker = new google.maps.Marker({
					position: {
						lat: parseFloat( data['lat'] ),
						lng: parseFloat( data['lng'] )
					},
					icon: '/wp-content/themes/trimark-framework/dist/images/icons/icon-pin.svg',
					map: this.map
				});
	
				// Append to reference for later use.
				this.map.markers.push( marker );
	
				// If marker contains HTML, add it to an infoWindow.
				if( data.name.length ){
	
					// Create info window.
					const infowindow = new google.maps.InfoWindow({
						content: data.name
					});
	
					// Show info window when marker is clicked.
					google.maps.event.addListener(marker, 'click', function() {
						infowindow.open( this.map, marker );
					});
				}
			},
			centerMap: function() {
				const bounds = new google.maps.LatLngBounds();
				this.map.markers.forEach(function( marker ){
					bounds.extend({
						lat: marker.position.lat(),
						lng: marker.position.lng()
					});
				});
	
				// Case: Single marker.
				if( this.map.markers.length == 1 ){
					this.map.setCenter( bounds.getCenter() );
	
				// Case: Multiple markers.
				} else{
					this.map.fitBounds( bounds );
				}
			}
		}
	
		if ($selector.length && typeof google !== 'undefined') {
			module.init();
		}
	
		return module;
	}
	
	
	/**
	 * Register after jQuery doc ready
	 */
	$(() => {
		new InteractiveMap($('.map-element'));
	});
	
	const LoadMoreBlock = function(selector, opts) {
		const module = {
			opts: {
				$el: $(selector),
				loadMoreSelector: '[data-load-more]',
				showAllSelector: '[data-show-all]',
				cardSelector: '.block',
				chunkSize: $(window).width() >= 992 ? opts.chunkSize.desktop : opts.chunkSize.mobile,
			},
			bindEvents: function() {
				$(this.opts.loadMoreSelector).on('click', this.loadMore.bind(this));
				$(this.opts.showAllSelector).on('click', this.showAllRemaining.bind(this));
			},
			init: function() {
				this.opts.$el.each(this.setupCards.bind(this));
				this.bindEvents();
			},
			setupCards: function(i, el) {
				const $section = $(el);
				const $cards = $section.find(this.opts.cardSelector);
				const chunkSize = this.opts.chunkSize === -1 ? $cards.length : this.opts.chunkSize;
				const data = {
					chunks: [],
					currentChunk: 0,
					total: $cards.length,
				};
	
				// Loop through and chunk cards into an array we can paginate over
				for (let i = 0; i < $cards.length; i += chunkSize) {
					data.chunks.push($cards.slice(i, i + chunkSize));
				}
	
				// Store data on the jQuery object
				$section.data('loadMoreData', data);
	
				// Check if we should hide the load more button
				if (data.chunks.length > 0 && data.total <= chunkSize) {
					$section.find(this.opts.loadMoreSelector).hide();
					$section.find(this.opts.showAllSelector).hide();
				}
	
				$cards.hide();
	
				this.loadMore($section);
			},
			loadMore: function($el) {
				let { chunks, currentChunk } = $el.data('loadMoreData');
				chunks[currentChunk].show();
				currentChunk++;
	
				if (currentChunk === chunks.length) {
					$(this.opts.loadMoreSelector).hide();
				}
			},
			showAllRemaining: function(e) {
				const $section = $(e.currentTarget).parents().filter(this.opts.$el);
				$section.find(`${this.opts.cardSelector}:not(:visible)`).show();
				$section.find(this.opts.showAllSelector).hide();
				$section.trigger('trmk.loadMoreBlock.showAll');
			},
		}
	
		if (module.opts.$el.length) {
			module.init();
		}
	
		return module;
	}
	
	/**
	 * Block Load More Grid
	 */
	const loadMoreGrid = new LoadMoreBlock('.block-load-more-grid', {
		chunkSize: {
			desktop: -1,
			mobile: 3,
		}
	});
	
	/**
	 * Helper function for resizing background images
	 *
	 * @param {*} $images
	 */
	const baGalleryImageResize = $images => {
		$images.each((i, el) => {
			const $this = $(el);
			const aspect = parseFloat($this.data('aspect'));
			const isPortrait = aspect >= 1;
			const $parent = $this.parent();
	
			// Calculate what the new width should be based on the height of the parent container
			const newWidth = $parent.outerHeight() / aspect;
	
			// Set the background size proportional to the containing element (accounting for original aspect ratio)
			// - If the image is a portrait orientation
			// - Or if the width of the image is smaller than the parent
			// - Calculate the image height based on the width of the parent
			if (isPortrait || newWidth < $parent.outerWidth()) {
				const newHeight = $parent.outerWidth() * aspect;
				$this.css('background-size', `${$parent.outerWidth()}px ${newHeight}px`);
			// Otherwise, fallback to setting the image width based on the parent height
			} else {
				$this.css('background-size', `${newWidth}px ${$parent.outerHeight()}px`);
			}
	
			// Signal initialized
			$parent.addClass('initialized');
		});
	}
	
	/**
	 * Size all background images on page load
	 */
	baGalleryImageResize($('.ba-image__slot'));
	
	/**
	 * Bind input[type=range] element to revealing images.
	 * Trigger change on page load so images start at correct size.
	 */
	$(".ba-image__slider").on("input change", e => {
		const sliderPos = parseInt(e.target.value);
		const $this = $(e.currentTarget);
		const $parent = $this.parents('.ba-image');
	
		// Update the width of the foreground image
		$parent.find('.foreground').css('width', `${sliderPos-0.5}%`);
	
		// Update the position of the slider button
		$this.siblings('.ba-image__slider-handle').css('left', `calc(${sliderPos}% - 23px)`)
	}).trigger('change');
	
	/**
	 * Listen for load more events and resize/init images
	 */
	$('.block-load-more-grid').on('trmk.loadMoreBlock.showAll', e => {
		baGalleryImageResize($(e.currentTarget).find('.ba-image__slot'));
	});
	
	$('.block-image-slider').each((index, element) => {
		const $slider = $(element).find('.image-slider__main');
		const $nav = $(element).find('.image-slider__nav');
	
		$slider.slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			fade: true,
			asNavFor: $nav,
			arrows: false,
		});
	
		$nav.slick({
			slidesToShow: 5,
			slidesToScroll: 1,
			asNavFor: $slider,
			dots: false,
			focusOnSelect: true,
			infinite: false,
			nextArrow: Globals.sliders.nextArrow,
			prevArrow: Globals.sliders.prevArrow,
			responsive: [
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 3,
					},
				},
			],
		});
	
	});
	
	document.addEventListener('DOMContentLoaded', function () {
		// Add 'three-cards' class if exactly 3 cards exist
		document.querySelectorAll('.horizontal-accordion').forEach(accordion => {
			if (accordion.querySelectorAll('.block-link-card').length === 3) {
				accordion.classList.add('three-cards');
			}
		});
	
		// jQuery accordion logic
		const $accordionItems = $('.horizontal-accordion .link-card');
		const $dotsContainer = $('.accordion-dots');
		const $nextBtn = $('.js-slider-controls .next');
		const $prevBtn = $('.js-slider-controls .prev');
	
		if (!$accordionItems.length) return;
	
		let currentIndex = 0;
	
		const setActiveItem = (index) => {
			$accordionItems.addClass('closed').each(function () {
				$(this).closest('.block-link-card').addClass('closed');
			});
	
			$accordionItems.eq(index).removeClass('closed').closest('.block-link-card').removeClass('closed');
			currentIndex = index;
	
			$dotsContainer.find('button').removeClass('active').eq(index).addClass('active');
		};
	
		// Generate dots
		$accordionItems.each((i) => {
			$('<button>', {
				type: 'button',
				'aria-label': `Go to item ${i + 1}`,
				class: i === 0 ? 'active' : '',
				click: () => setActiveItem(i)
			}).appendTo($dotsContainer);
		});
	
		// Initialize
		setActiveItem(0);
	
		// Click handler for items
		$accordionItems.on('click', function (e) {
			if (!$(this).hasClass('closed')) return;
			e.preventDefault();
			setActiveItem($accordionItems.index(this));
		});
	
		// Arrow navigation
		$nextBtn.on('click', () => setActiveItem((currentIndex + 1) % $accordionItems.length));
		$prevBtn.on('click', () => setActiveItem((currentIndex - 1 + $accordionItems.length) % $accordionItems.length));
	});
	

	// ========================================================
	// SUPERSCRIPTS
	// Replace symbols with subscripted or superscripted versions
	// ========================================================
	$("p,h1,h2,h3,h4,li,a").each(function () {
		var $this = $(this);
		// Superscripts (English)
		$this.html($this.html().replace(/&dagger;|†/gi, '<sup>&dagger;</sup>'));
		$this.html($this.html().replace(/&Dagger;|‡/gi, '<sup>&Dagger;</sup>'));
		$this.html($this.html().replace(/&reg;|®/gi, '<sup>&reg;</sup>'));
		$this.html($this.html().replace(/&trade;|™/gi, '<sup>&trade;</sup>'));
		// Superscripts (French)
		$this.html($this.html().replace(/🅫/gi, '<sup>&trade;</sup>'));
		$this.html($this.html().replace(/🅪/gi, '<sup>&trade;</sup>'));
	});

	// ========================================================
	// GENERIC SLICK SLIDER
	// - Control options with data-slick
	// ========================================================

	const $sliders = $('.js-slider');

	function initGenericSlickSlider(el) {
		const $slider = $(el);
		const $controls = $slider.next('.js-slider-controls');
		const $filler = $slider.find('.is-col-filler');
		const { nextArrow, prevArrow } = Globals.sliders;

		// Initialize Slick
		$slider.slick({
			nextArrow,
			prevArrow,
		});

		// If there is a controls slot, add arrows and dots there.
		if ($controls.length) {
			$slider.slick('setOption', 'appendDots', $controls, true);
			$slider.slick('setOption', 'appendArrows', $controls, true);
		}

		// Remove any filler cards
		if ($filler.length) {
			const lastSlide = $slider.find('[data-slick-index]').length - 1;
			$slider.slick('slickRemove', lastSlide);
		}

		// Remove accessibility attributes if slick has not been initialized (I.e. desktop "unslick")
		if ($slider.find('.slick-track').length === 0) {
			$slider.find('> *').removeAttr('aria-describedby role tabindex aria-hidden');
			$slider.find('a[tabindex="-1"], button[tabindex="-1"]').removeAttr('tabindex');
		}
	}

	// Check for sliders and loop through each
	if ($sliders.length) {
		$sliders.each((i, el) => initGenericSlickSlider(el));
	}

	jQuery(document).on( 'gform_confirmation_loaded', function (event, formId) {
		initGenericSlickSlider(document.querySelector(`#gform_wrapper_${formId} .js-slider`));
		$(`#gform_wrapper_${formId} a[href="#popupForm"]`).fancybox({
			baseClass: 'fancybox-fullscreen-popup-form',
			touch: false,
		});
	});

	// ========================================================
	// GRAVITY FORMS FLOATING LABELS
	// - Using Bootstrap 5's floating labels
	// - @link https://getbootstrap.com/docs/5.3/forms/floating-labels/
	// ========================================================

	const fields = [
		'.gfield--type-text label',
		'.gfield--type-phone label',
		'.gfield--type-email label',
		'.gfield--type-name label',
		'.gfield--type-select label',
		'.gfield--type-textarea label',
		'.gfield--type-address label'
	];

	function initFloatingLabels(formId) {
		// All field labels
		$(`#gform_${formId}`).find(fields.join(',')).each((i, el) => {
			const $label = $(el);
			const $field = $label.parents('.gfield');
			let $container = $label.next('.ginput_container');

			// Complex fields (i.e. name or address fields)
			if ($field.hasClass('gfield--type-name') || $field.hasClass('gfield--type-address')) {
				$container = $label.parent();
			}

			// Return if already initialized (i.e. label already moved)
			if ($container.length === 0) {
				return;
			}

			// Add Bootstrap class (except select boxes)
			if (!$field.hasClass('gfield--type-select') && !$container.hasClass('ginput_address_country')) {
				$container.addClass('form-floating');
			}

			// Move label into correct position
			$label.remove().appendTo($container);
		});
		// Special handling for select forms only on change event
		$('.gfield--type-select select, .ginput_address_country select').on('change', e => {
			$(e.currentTarget).parent().addClass('form-floating');
		});
	}

	// Init floating labels on page load
	$('.gform_wrapper form').each((i, el) => initFloatingLabels($(el).data('formid')));

	// Gravity forms post render hook to reinit after validation or paging
	$(document).on('gform_post_render', function (event, form_id, current_page) {
		initFloatingLabels(form_id);
	});

	// ========================================================
	// BOOTSTRAP TOOLTIPS
	// ========================================================

	const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
	const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))

	// ========================================================
	// FANCYBOX 3.5
	// @link https://obu.edu/_resources/ldp/galleries/fancybox/#options
	// ========================================================

	/**
	 * Full screen popup
	 */
	$('a[href="#popupForm"]').fancybox({
		baseClass: 'fancybox-fullscreen-popup-form',
		touch: false,
	});

	/**
	 * Default close button for all Fancybox popups
	 */
	const fancyBoxCloseBtnTemplate = `
		<button type="button" data-fancybox-close class="fancybox-button fancybox-close-small" title="{{CLOSE}}">
			CLOSE
			<svg xmlns="http://www.w3.org/2000/svg" width="19.092" height="19.092"><g fill="none" stroke="#fff" stroke-linecap="round" stroke-width="2" data-name="Group 1064"><path d="m1.414 1.414 16.263 16.263" data-name="Line 15"/><path d="M17.678 1.414 1.415 17.677" data-name="Line 16"/></g></svg>
		</button>`;

	$.fancybox.defaults.btnTpl.smallBtn = fancyBoxCloseBtnTemplate;
	$.fancybox.defaults.btnTpl.close = fancyBoxCloseBtnTemplate;


	// ========================================================
	// Clicking or focusing on hotspot will automatically scroll
	// (or focus) on corresponding card.
	// - Relies on the section with the .hotspot-image block to be immediately
	// 	 followed by a .block-cards-to-accordion block
	// ========================================================

	$('.hotspot-image .hotspot').on('click', e => {
		const $this = $(e.currentTarget);
		const $section = $this.parents('.block-section');
		const target = $section.find('.cards-to-accordion').attr('id') + '-' + $this.data('id');
		$(`#${target}`).find('.ca-item__title').trigger('focus');
	});

	// ========================================================
	// CHAT WINDOW
	// - Any links with href="#chat" will trigger a click on Apex Chat
	// - Apex chat loads in iframe so we have to listen for when it's fully loaded.
	// ========================================================

	const findEventShowChat = setInterval(function() {
        let iframePopupChat = document.getElementById('apexchat_prechat_invitation_frame');
		let elmntWrapPopupChat;

        if (iframePopupChat) {
            elmntWrapPopupChat = iframePopupChat.contentWindow.document.getElementById('apexchat_prechat_chat_icon');
        }

        if (elmntWrapPopupChat) {
            $('a[href="#chat"]').on('click', e => {
                e.preventDefault();
                elmntWrapPopupChat.click();
            });
            clearInterval(findEventShowChat);
        }
    }, 1000);

	// ========================================================
	// ACCORDIONS
	// ========================================================

	$('.block-accordion .accordion-button').on('focusin focusout', e => {
		// Throw a quick focus class on so we can tell when parent item is focused
		$(e.currentTarget).parent('.accordion-item').toggleClass('is-focus');
	});

	// ========================================================
	// SIMPLE NUMBER COUNTDOWN
	// ========================================================

	$('[data-countdown]').each((i, el) => {
		let timeleft = parseInt($(el).data('countdown'));
		const downloadTimer = setInterval(function () {
			if (timeleft <= 0) {
				clearInterval(downloadTimer);
				el.innerHTML = '0';
			} else {
				el.innerHTML = timeleft;
			}
			timeleft -= 1;
		}, 1000);
	});

	// ========================================================
	// WINDOW TAB MESSAGE
	// ========================================================

	function windowTabMessage() {
		// Get the current page title
		var pageTitle = $('TITLE').text();
		// Get the custom tab message
		var customTitle = '(1) Offer Waiting...';
		// On blur update with custom message
		$(window).on('blur', () => $('TITLE').text(customTitle + ' ' + pageTitle));
		// Revert to default title on focus
		$(window).on('focus', () => $('TITLE').text(pageTitle));
	}
	windowTabMessage();



	// ========================================================
	// GRAVITY FORMS PROGRESS BAR STEPS
	// - Turns the default progress bar percentage text into a steps text (i.e. 2/5)
	// ========================================================

	const ProgressBarSteps = {
		_selectors: {
			wrapper: '.gf_progressbar_wrapper',
			percentage: '.gf_progressbar_percentage',
			title: '.gf_progressbar_title',
			currentPage: '.gf_step_current_page',
			totalPages: '.gf_step_page_count',
			stepEl: '.trmk-progress-steps',
		},
		_getTotalPages: function() {
			const $wrapper = $(this._selectors.wrapper);
			let totalPages = $wrapper.find(this._selectors.totalPages).text();
			if ($wrapper.data('start-at-zero') == true) {
				totalPages = parseInt(totalPages) - 1;
			}
			return totalPages;
		},
		_getStepMarkup: function(current) {
			const $wrapper = $(this._selectors.wrapper);
			if (current > 0 && $wrapper.data('start-at-zero') == true) {
				current = parseInt(current) - 1;
			}
			return `<span class="${this._selectors.stepEl.replace(/^\./, '')}">${current}/${this._getTotalPages()}</span>`;
		},
		init: function() {
			const $wrapper = $(this._selectors.wrapper);
			$wrapper.each((i, wrapper) => {
				const totalPages = this._getTotalPages();
				$(wrapper).find(this._selectors.percentage).append(this._getStepMarkup(0));
			});
		},
		update: function(formId) {
			const $wrapper = $(`#gf_progressbar_wrapper_${formId}`);
			const $percentage = $wrapper.find(this._selectors.percentage);
			const $current = $wrapper.find(this._selectors.currentPage);
			$percentage.append(this._getStepMarkup($current.text()));
		}
	}
	// Initialize the progress bar steps on page load
	ProgressBarSteps.init();
	// Update the progress bar steps on each form page
	$(document).on('gform_page_loaded', function(event, form_id, current_page) {
		ProgressBarSteps.update(form_id);
	});


})(jQuery);
